import { Device, Product, Timezone, UserImp } from '../../../index';
import { Country } from '../countries/countries.interfaces';

/**
 * Installation interface
 */
export interface Installation {
  id: number;
  name?: string;
  address?: string;
  addressLine1?: string;
  postalCode?: string;
  city?: string;
  country?: Country;
  timezone?: Timezone;
  favorite?: boolean;
  delivered?: boolean;
  deliveredAt?: Date;
  owner?: UserImp;
  installer?: UserImp;
  added?: string;
  devices?: Device[];
  installerAccessFrom?: Date;
  installerAccessUntil?: Date;
  installerIdConfirmed?: boolean;
  ownerIdConfirmed?: boolean;
  allowedCtdCount?: number;
  ctdCount?: number;
  isShared: boolean;
  originId?: number; // 1 = QC, 2 = QCP
  installerVisualisationAccess?: boolean;
  installerConfigurationAccess?: boolean;
  installer2?: UserImp;
  installer2IdConfirmed?: boolean;
  installer2VisualisationAccess?: boolean;
  installer2ConfigurationAccess?: boolean;
}

/**
 * Installation
 */
export class InstallationImp implements Installation {
  id = 0;
  name?: string;
  addressLine1?: string;
  postalCode?: string;
  city?: string;
  country?: Country;
  timezone?: Timezone;
  favorite?: boolean;
  delivered?: boolean;
  deliveredAt?: Date;
  owner?: UserImp;
  installer?: UserImp;
  added?: string;
  devices?: Device[];
  license?: Product;
  installerAccessFrom?: Date;
  installerAccessUntil?: Date;
  installerIdConfirmed?: boolean;
  allowedCtdCount?: number;
  ownerIdConfirmed?: boolean;
  ctdCount?: number;
  isShared = false;
  originId?: number;
  installerVisualisationAccess?: boolean;
  installerConfigurationAccess?: boolean;
  installer2?: UserImp;
  installer2IdConfirmed?: boolean;
  installer2VisualisationAccess?: boolean;
  installer2ConfigurationAccess?: boolean;

  get address(): string {
    let address = '';

    if (this.addressLine1) {
      address = this.addressLine1;
    }

    if (this.postalCode) {
      address += ', ' + this.postalCode;
    }

    if (this.city) {
      address += ', ' + this.city;
    }

    if (this.country && this.country.name !== undefined) {
      address += ', ' + this.country.name;
    }
    return address;
  }
}

export interface AddDeviceRequest {
  readonly serialNumber: string;
  readonly activationKey: string;
  readonly timeZoneId: string;
}

export interface AddInstallationRequest {
  readonly name: string;
  readonly addressLine1: string;
  readonly postalCode: string;
  readonly city: string;
  readonly country: string;
  // will be automatically set to device timezone on backend if undefined
  readonly timeZoneId?: string;
}

export interface AddDeviceToNewInstallationRequest {
  readonly device: AddDeviceRequest;
  readonly installation: AddInstallationRequest;
}

export interface UpdateInstallationRequest {
  readonly name: string;
  readonly addressLine1: string;
  readonly postalCode: string;
  readonly city: string;
  readonly country: string;
  readonly timeZoneId?: string;
  readonly favorite: boolean;
  readonly forceGeocoding?: boolean;
  readonly networkDeviceId?: number;
}
